{
  "version": 1,
  "asset_id": "1ffa93ea-3041-43f0-b4b3-95adcd8020f4",
  "project_id": "7948fbe6-b4e3-485f-995c-f8f53bd7ab6b",
  "url": "/__l5e/assets-v1/1ffa93ea-3041-43f0-b4b3-95adcd8020f4/arwen-motion.mp4",
  "r2_key": "a/v1/7948fbe6-b4e3-485f-995c-f8f53bd7ab6b/1ffa93ea-3041-43f0-b4b3-95adcd8020f4/arwen-motion.mp4",
  "original_filename": "arwen-motion.mp4",
  "size": 8442569,
  "content_type": "video/mp4",
  "created_at": "2026-07-05T03:24:54Z"
}
